export default __webpack_public_path__ + "static/media/ClubeDoParque.124b65ab.svg";